import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  CircularProgress,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Chip,
} from "@mui/material";

function WellnessAdmin() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const fetchRows = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await fetch("https://api.cri.co.in/api/admin/list"); // ✅ backend endpoint below
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Failed to load data");
      }
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;

    return rows.filter((r) => {
      const hay = [
        r.wellness_option,
        r.company_name,
        r.employee_code,
        r.employee_id,
        r.email,
        r.mobile,
        r.relationship,
        String(r.id),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return hay.includes(s);
    });
  }, [rows, q]);

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 3,
          border: "1px solid #e0e0e0",
          background: "#fff",
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 800, color: "#0d47a1" }}>
          Wellness Admin
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Total entries: <b>{rows.length}</b>
        </Typography>

        <Box sx={{ mt: 2, display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            label="Search (company / code / email / option / mobile...)"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            fullWidth
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {err && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {err}
            </Alert>
          )}

          {!loading && !err && (
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><b>ID</b></TableCell>
                    <TableCell><b>Wellness Option</b></TableCell>
                    <TableCell><b>Company Name</b></TableCell>
                    <TableCell><b>Employee Code</b></TableCell>
                    <TableCell><b>Employee ID</b></TableCell>
                    <TableCell><b>Email</b></TableCell>
                    <TableCell><b>Mobile</b></TableCell>
                    <TableCell><b>Relationship</b></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filtered.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                        No records found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    filtered.map((r) => (
                      <TableRow key={r.id} hover>
                        <TableCell>{r.id}</TableCell>
                        <TableCell>
                          <Chip
                            label={r.wellness_option || "-"}
                            size="small"
                            sx={{ backgroundColor: "#e3f2fd" }}
                          />
                        </TableCell>
                        <TableCell>{r.company_name || "-"}</TableCell>
                        <TableCell>{r.employee_code || "-"}</TableCell>
                        <TableCell>{r.employee_id || "-"}</TableCell>
                        <TableCell>{r.email || "-"}</TableCell>
                        <TableCell>{r.mobile || "-"}</TableCell>
                        <TableCell>{r.relationship || "-"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    </Container>
  );
}

export default WellnessAdmin;